// 객실현황 리스트

import { useMutation } from "@tanstack/react-query";
import { IRmPdStas } from "interface/rm/crr";
import { useEffect, useRef } from "react";
import useLodStore from "store/lod";
import { useCalendarContext } from "./context";
import { rmPdStasApi } from "components/api/rm";
import { apifield } from "components/utils/comm";

// 객실 현황리스트 가져오기
export const useGetRoomStatusData = ({
  start,
  end,
}: {
  start: string | undefined;
  end: string | undefined;
}) => {
  const lod = useLodStore((state) => state.lod);

  const { now } = useCalendarContext();
  const pdListRef = useRef<IRmPdStas[]>([]);

  const mutation = useMutation({
    mutationKey: ["room-room-status"],
    mutationFn: rmPdStasApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 객실 현황 리스트
          pdListRef.current = data.rmPdStaList;
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (start && end) {
      const params = {
        lodNo: lod?.lodNo ?? "",
        sellSDt: start,
        sellEDt: end,
      };
      mutation.mutate(params);
    }
  }, [now]);

  return { pdList: pdListRef.current };
};
